import React from 'react'
import { tokens, Select } from '@arvoreeducacao/bonsai-ds'
import { withRouter } from 'react-router-dom'
// eslint-disable-next-line no-restricted-imports
import { withApollo } from '@apollo/client/react/hoc'
import { compose } from 'utils/compose'
import Loader from 'components/loader'
import SpinnerLoader from 'components/loader/SpinnerLoader'
import { ModalNotYourSchool } from 'components/lib/modals'
import { useSchoolConfirmationLogin } from './SchoolConfirmationLogin.hooks'
import { SCHOOL_YEARS } from './schoolYears'
import Cdn from 'utils/assets/Cdn'
import {
  SelectTitle,
  CustomInput,
  SelectResultsWrapper,
  CustomSelectResult
} from 'components/family-paying-access/selects/Selects.styles'
import {
  StyledImage,
  Title,
  Content,
  ButtonWrapper,
  CustomButton,
  Text,
  BackArrowButton,
  LoaderWrapper,
  SelectWrapper,
  InlineSpinnerWrapper,
  WarningBox,
  WarningIcon,
  WarningText,
  SchoolInfoWrapper,
  SchoolInfo,
  CustomIcon
} from './SchoolConfirmationLogin.styles'

const SchoolConfirmationLogin = ({ match, client, ...props }) => {
  const { history } = props
  const hooksProps = { history, client, match }

  const { states, handlers } = useSchoolConfirmationLogin(hooksProps)
  const {
    toggleShowHelpModal,
    handleUnitSelect,
    handleYearSelect,
    handleReaderSearchChange,
    eraseField,
    handleReaderClick,
    handleNextPage
  } = handlers
  const {
    schoolFound,
    schoolRootId,
    entityName,
    hierarchyType,
    units,
    selectedUnitId,
    selectedUnitName,
    selectedYear,
    readersFound,
    selectedReaderId,
    selectedReaderName,
    noReaderFound,
    loadingUnits,
    loadingReaders,
    showHelpModal,
    isSubmitting
  } = states

  if (!schoolFound) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    )
  }

  return (
    <Content>
      <ModalNotYourSchool
        showModal={showHelpModal}
        dismissModal={toggleShowHelpModal}
      />
      <BackArrowButton
        data-testid="back-arrow"
        iconName="arrow-left"
        bgColor={tokens.colors.white}
        bgColorHover={tokens.colors.black1}
        iconColor={tokens.colors.black5}
        onClick={() => history.goBack()}
      />
      <StyledImage
        src={Cdn.getImageUrl('payment-page/boleto.png')}
        alt="Plataforma de leitura Árvore"
      />
      <Text>Assinatura Árvore</Text>
      <Title>Confirme a instituição</Title>
      {entityName && (
        <SchoolInfoWrapper>
          <SchoolInfo>
            <CustomIcon iconName="school" size={24} />
            {entityName}
          </SchoolInfo>
        </SchoolInfoWrapper>
      )}
      {schoolRootId && units.length > 0 && hierarchyType === 'network' && (
        <SelectWrapper>
          <Select
            items={units.map(unit => ({
              id: unit.id,
              text: unit.name
            }))}
            placeholder="Selecione uma unidade"
            onChange={(item: { id: number; text: string }) =>
              handleUnitSelect(item.id, item.text)
            }
            value={
              selectedUnitId
                ? { id: selectedUnitId, text: selectedUnitName }
                : undefined
            }
            disabled={loadingUnits}
          />
        </SelectWrapper>
      )}
      {selectedUnitId && (
        <SelectWrapper>
          <Select
            items={SCHOOL_YEARS as Array<{ id: string; text: string }>}
            placeholder="Selecione o ano escolar"
            onChange={(item: { id: string; text: string }) =>
              handleYearSelect(item.id)
            }
            value={
              selectedYear
                ? SCHOOL_YEARS.find(year => year.id === selectedYear)
                : undefined
            }
          />
          {!selectedYear && (
            <WarningBox>
              <WarningIcon iconName="warning" size={20} />
              <WarningText>
                Atenção: o ano escolar deve ser aquele que o estudante vai
                cursar em 2026.
              </WarningText>
            </WarningBox>
          )}
        </SelectWrapper>
      )}
      {selectedYear && (
        <SelectWrapper>
          <SelectTitle error={noReaderFound || undefined}>
            Nome completo
          </SelectTitle>
          <CustomInput
            error={noReaderFound || undefined}
            value={selectedReaderName || ''}
            helpText="Digite o nome e sobrenome"
            onKeyDown={eraseField}
            onChange={event => handleReaderSearchChange(event.target.value)}
            disabled={loadingReaders}
          />
          {loadingReaders && (
            <InlineSpinnerWrapper>
              <SpinnerLoader size="24px" />
            </InlineSpinnerWrapper>
          )}
          <SelectResultsWrapper>
            {Boolean(readersFound.length) &&
              readersFound.map(reader => (
                <CustomSelectResult
                  key={reader.id}
                  onClick={() => handleReaderClick(reader)}
                >
                  {reader.name}
                </CustomSelectResult>
              ))}
          </SelectResultsWrapper>
          {noReaderFound &&
            selectedReaderName.trim().length > 0 &&
            !loadingReaders && (
              <WarningBox>
                <WarningIcon iconName="warning" size={20} />
                <WarningText>
                  Aluno não encontrado. Entre em contato conosco por{' '}
                  <a href="mailto:atendimento@arvore.com.br">
                    atendimento@arvore.com.br
                  </a>{' '}
                  ou WhatsApp{' '}
                  <a
                    href="https://wa.me/5521981661218"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    (21) 98166-1218
                  </a>
                  .
                </WarningText>
              </WarningBox>
            )}
        </SelectWrapper>
      )}
      {loadingUnits && (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      )}
      <ButtonWrapper>
        <CustomButton
          data-testid="confirm-button"
          primary
          large
          onClick={handleNextPage}
          disabled={
            !selectedUnitId ||
            !selectedYear ||
            !selectedReaderId ||
            isSubmitting
          }
          loading={isSubmitting}
        >
          Confirmar e avançar
        </CustomButton>
      </ButtonWrapper>
    </Content>
  )
}

export default compose(withRouter, withApollo)(SchoolConfirmationLogin)
